(function () {
  'use strict';

  function formatShipDate() {
    var d = new Date();

    // Made to order: 5 calendar weeks from today.
    // If that date falls on a weekend, use the preceding Friday.
    d.setDate(d.getDate() + 35);

    if (d.getDay() === 6) {
      d.setDate(d.getDate() - 1);
    } else if (d.getDay() === 0) {
      d.setDate(d.getDate() - 2);
    }

    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }).format(d);
  }

  function setup(statusEl) {
    var form = statusEl.closest('product-form');
    if (!form) return;

    var productForm = form.querySelector('form');
    if (!productForm) return;

    var variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;

    var dataEl = statusEl.querySelector('[data-zt-status-variant-data]');
    if (!dataEl) return;

    var variants;

    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function getCurrentVariant() {
      var id = String(variantInput.value);

      return variants.find(function (variant) {
        return String(variant.id) === id;
      });
    }

    function render() {
      var variant = getCurrentVariant();
      if (!variant) return;

      var inStock = Number(variant.inventory_quantity) > 0;

      if (inStock) {
        statusEl.innerHTML =
          '<strong>In Stock</strong><span class="zt-status-dot">•</span><span>Ready to Ship</span>';
      } else {
        statusEl.innerHTML =
          '<strong>Made to Order</strong><span class="zt-status-dot">•</span><span>Ships by ' +
          formatShipDate() +
          '</span>';
      }
    }

    document.addEventListener('change', function () {
      setTimeout(render, 60);
    });

    document.addEventListener('click', function () {
      setTimeout(render, 100);
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-zt-variant-status]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();